<template>
  <router-view />
</template>

<script lang="tsx" setup></script>
